import React from 'react'
import Hero from '../components/Hero'
import HighLights from '../components/HighLights'
import Model from '../components/Model'
import Features from '../components/Features'
import HowItWorks from '../components/HowItWorks'

const HomeiPHONE = () => {
  return (
    <div>
      <Hero />
      <HighLights />
      <Model />
      <Features />
      <HowItWorks />
    </div>
  )
}

export default HomeiPHONE
